<template>
    <apexchart  :height= height :options="chartOptions" :series="dataArray" class="chartPie"></apexchart>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'


export default {
    components: { apexchart: VueApexCharts},
    props: ['dataArray', 'chartPieCategories', 'height', 'total'],   

    
     // VERDE ,   AMARELO, CINZA, VERMVELHO
    // colors: ['#78f4a2b3','#ffc70080', '#C4C4C4' , '#ff292980'],
    // labels: this.chartPieCategories,    
    data() {
        return {
          chartOptions: {
            chart: {
             
              type: 'radialBar',
            },
            plotOptions: {

            
        
               radialBar: {
                offsetY: -20,
        
                hollow: {
                  margin: 0,
                  size: '15%',
                  background: 'transparent',
                  image: undefined,
                },

                 track: {
                  show: true,
                  startAngle: undefined,
                  endAngle: undefined,
                  background: '#e0e0e073',
                  strokeWidth: '97%',
                  opacity: 1,
                  margin: 5, 
                  dropShadow: {
                      enabled: false,
                      top: 0,
                      left: 0,
                      blur: 3,
                      opacity: 0.5
                  }
              },
                dataLabels: {
                  name: {
                    show: false,
                  },
                  value: {
                    show: false,
                  }
                }
              }
            },
            labels:["Inclui texto", "Alterou texto", "Não Alterou Texto" , "Revogou texto"],
            colors: ['#78f4a2b3','#ffc70080', '#404040' , '#ff292980'],
            legend: {
              show: true,
              floating: false,
              fontSize: '12px',
              position: 'bottom',
              horizontalAlign: 'left', 
              offsetX: 40,
              offsetY: -20,
              labels: {
                useSeriesColors: false,
              },
              
              formatter: function(seriesName, opts) {
                let percent = opts.w.globals.series[opts.seriesIndex];
                return seriesName + ":  " + percent +'%'
              },
             
            },
          },
          
        }
    },


}
</script>

<style scoped lang="scss">

.chartPie{
  min-height: 350px !important;
  .apexcharts-canvas{
    padding-top:0 !important;
  }
}

</style>

